module.exports = __webpack_public_path__ + "img/chargingpoint-realized-private.d3fc83d1.svg";